import { ErrorBoundary } from 'react-error-boundary';
import FallbackComponent from './FallbackComponent';

const GlobalErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent}
      onReset={() => window.location.replace('/')}
    >
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
